import React from 'react'
import { CloseIcon, IconButton, Text } from '@resiliatech/birdsong'
import {
  ContentWrapper,
  Title,
  StyledDialogContent,
  ContentSection,
  ButtonContainer,
  HeaderContainer,
  Popover,
  MessageBox,
  StyledAlert,
} from './MessagePopover.styled'
import { PopoverButton } from './PopoverButton'
import { ButtonConfig, AlertColor } from './types'

type MessagePopoverProps = {
  open: boolean
  onClose: () => void
  alertColor: AlertColor
  alertMessage: string
  title: string
  content?: JSX.Element | undefined | string
  primaryButton: ButtonConfig
  secondaryButton?: ButtonConfig
  showConfirmButtons?: boolean
}

export const MessagePopover = ({
  open,
  onClose,
  alertColor,
  alertMessage,
  title,
  content,
  primaryButton,
  secondaryButton,
  showConfirmButtons,
}: MessagePopoverProps) => (
  <Popover
    open={open}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    BackdropProps={{
      invisible: true,
      style: { backgroundColor: 'rgba(26, 26, 26, 0.5)' },
    }}
  >
    <ContentWrapper>
      <HeaderContainer>
        <Title>{title}</Title>
        <IconButton onClick={onClose} size='small'>
          <CloseIcon />
        </IconButton>
      </HeaderContainer>
      <StyledDialogContent>
        <ContentSection>
          <StyledAlert severity={alertColor}>{alertMessage}</StyledAlert>
          <MessageBox>
            <Text variant='body2'>{content}</Text>
          </MessageBox>
        </ContentSection>
        <ButtonContainer>
          <PopoverButton
            primaryButton={primaryButton}
            secondaryButton={secondaryButton}
            showConfirmButtons={showConfirmButtons}
          />
        </ButtonContainer>
      </StyledDialogContent>
    </ContentWrapper>
  </Popover>
)
